export const HIDDEN_SERVICE_CODES = ['AMB', 'LD'];

export const MIN_CAR_SEAT_AGE = 3;
export const CAR_SEAT_AUTO_SELECT_MAX_AGE = 6;
